module.exports = __webpack_public_path__ + "static/media/logo.31ff52e6.svg";